import type {IAppDispatch} from "../../store/store";
import {IAuthSuccessTrackingParams, trackAuthSuccess} from "../tracking/track_auth_success";
import {authSucceeded, IAuthSucceededPayload} from "./auth_succeeded_event";

type AuthSucceededDetails = Pick<IAuthSucceededPayload, "registrationMethod" | "socialMediaType" | "authOrigin" | "postAuthFlowContext">;

export const reportAuthSuccess = (dispatch: IAppDispatch, params: IAuthSuccessTrackingParams, authSucceededDetails: AuthSucceededDetails) => {
    trackAuthSuccess(params);
    dispatch(authSucceeded({type: params.authActionType, userSource: params.userSource, gtmSourceSection: params.gtmSourceSection, ...authSucceededDetails}));
};
import type {IAppDispatch} from "../../store/store";
import {IAuthSuccessTrackingParams, trackAuthSuccess} from "../tracking/track_auth_success";
import {authSucceeded, IAuthSucceededPayload} from "./auth_succeeded_event";

type AuthSucceededDetails = Pick<IAuthSucceededPayload, "registrationMethod" | "socialMediaType" | "authOrigin" | "postAuthFlowContext">;

export const reportAuthSuccess = (dispatch: IAppDispatch, params: IAuthSuccessTrackingParams, authSucceededDetails: AuthSucceededDetails) => {
    trackAuthSuccess(params);
    dispatch(authSucceeded({type: params.authActionType, userSource: params.userSource, gtmSourceSection: params.gtmSourceSection, ...authSucceededDetails}));
};
